var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [_vm._v("这个页面不会被 keep-alive")]),
      _c("p", { staticClass: "d2-mt-0" }, [
        _vm._v(
          "在下面的输入框输入任意字符后，切换到其它页面，再回到此页时输入框文字消失，证明没有被缓存"
        )
      ]),
      _c("el-input", {
        attrs: { placeholder: "input here" },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }